import { styled } from '@mui/material/styles';
import { Select, MenuItem } from '@mui/material';
import { createColorFilteredComponent } from 'helpers/styledHelpers';

export const StyledLanguageSelect = styled(Select<string>)(({ theme }) => ({
  '& fieldset': {
    border: 'none',
  },
  '&:hover fieldset': {
    border: 'none',
  },
  '&.Mui-focused fieldset': {
    border: 'none',
  },
  '& .MuiSelect-icon': {
    color: theme.palette.black.main,
  }
}));

export const StyledMenuItem = createColorFilteredComponent<{ $color: string }>(MenuItem)(({ $color }) => ({
  color: $color
})); 